(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["checkout-custom-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const backToTop = document.getElementById('BackToTop');
    if (!backToTop) return;
    
    // 滚动显示/隐藏返回顶部按钮
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 300) {
        backToTop.classList.add('visible');
      } else {
        backToTop.classList.remove('visible');
      }
    }, { passive: true });
    
    // 点击返回顶部
    backToTop.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kitchen-scissors-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    var track = document.querySelector('#ks-wrap .ks-video-track');
    var dotsContainer = document.querySelector('#ks-wrap .ks-video-dots');
    var prevBtn = document.querySelector('#ks-wrap .ks-video-arrow-prev');
    var nextBtn = document.querySelector('#ks-wrap .ks-video-arrow-next');

    if(!track) return;

    var originalCards = Array.prototype.slice.call(track.querySelectorAll('.ks-video-card'));
    if(!originalCards.length) return;

    var totalOriginal = originalCards.length;
    var isScrolling = false;
    var currentRealPage = 0;

    function getPerPage(){
      var w = window.innerWidth;
      if(w >= 750) return 3;
      return 2;
    }

    function getTotalRealPages(){
      var perPage = getPerPage();
      return Math.max(1, Math.ceil(totalOriginal / perPage));
    }

    function setupInfiniteLoop(){
      var perPage = getPerPage();
      var cloneCount = Math.min(perPage, totalOriginal);

      var existingClones = track.querySelectorAll('.ks-video-card.is-clone');
      for(var i = 0; i < existingClones.length; i++){
        track.removeChild(existingClones[i]);
      }

      for(var j = 0; j < totalOriginal; j++){
        var endClone = originalCards[j].cloneNode(true);
        endClone.classList.add('is-clone');
        track.appendChild(endClone);
      }

      for(var k = 0; k < totalOriginal; k++){
        var startClone = originalCards[totalOriginal - 1 - k].cloneNode(true);
        startClone.classList.add('is-clone');
        track.insertBefore(startClone, track.firstChild);
      }

      var allCards = track.querySelectorAll('.ks-video-card');
      allCards.forEach(function(card){
        var video = card.querySelector('video');
        if(video){
          video.pause();
          video.currentTime = 0;
        }
        card.classList.remove('playing');
        card.addEventListener('click', function(e){
          e.preventDefault();
          togglePlay(card);
        });
      });

      var firstRealCard = track.querySelectorAll('.ks-video-card')[totalOriginal];
      if(firstRealCard){
        track.scrollLeft = firstRealCard.offsetLeft - track.offsetLeft;
      }
    }

    function togglePlay(card){
      var video = card.querySelector('video');
      if(!video) return;

      if(card.classList.contains('playing')){
        video.pause();
        card.classList.remove('playing');
      } else {
        video.muted = true;
        video.playsInline = true;
        video.loop = true;
        if(video.currentTime > 0 && video.ended){
          video.currentTime = 0;
        }
        var playPromise = video.play();
        if(playPromise !== undefined){
          playPromise.then(function(){
            card.classList.add('playing');
          }).catch(function(){
            card.classList.remove('playing');
          });
        } else {
          card.classList.add('playing');
        }
      }
    }

    function getRealPageFromScroll(){
      var perPage = getPerPage();
      var totalRealPages = getTotalRealPages();
      var allCards = track.querySelectorAll('.ks-video-card');
      var scrollLeft = track.scrollLeft;

      var nearestRealIndex = 0;
      var nearestDist = Infinity;

      for(var i = totalOriginal; i < totalOriginal + totalOriginal; i++){
        if(i >= allCards.length) break;
        var card = allCards[i];
        var cardLeft = card.offsetLeft - track.offsetLeft;
        var dist = Math.abs(scrollLeft - cardLeft);
        if(dist < nearestDist){
          nearestDist = dist;
          nearestRealIndex = i - totalOriginal;
        }
      }

      var page = Math.floor(nearestRealIndex / perPage);
      return Math.max(0, Math.min(page, totalRealPages - 1));
    }

    function goToRealPage(realPage, smooth){
      if(smooth === undefined) smooth = true;
      var perPage = getPerPage();
      var cardIndex = totalOriginal + realPage * perPage;
      var allCards = track.querySelectorAll('.ks-video-card');
      if(cardIndex >= allCards.length) cardIndex = allCards.length - 1;
      var card = allCards[cardIndex];
      if(!card) return;
      var targetLeft = card.offsetLeft - track.offsetLeft;
      if(smooth){
        track.scrollTo({ left: targetLeft, behavior: 'smooth' });
      } else {
        track.scrollLeft = targetLeft;
      }
      currentRealPage = realPage;
      updateDots();
    }

    function nextPage(){
      var totalRealPages = getTotalRealPages();
      var nextRealPage = (currentRealPage + 1) % totalRealPages;
      goToRealPage(nextRealPage, true);
    }

    function prevPage(){
      var totalRealPages = getTotalRealPages();
      var prevRealPage = (currentRealPage - 1 + totalRealPages) % totalRealPages;
      goToRealPage(prevRealPage, true);
    }

    function handleScrollEnd(){
      var allCards = track.querySelectorAll('.ks-video-card');
      var scrollLeft = track.scrollLeft;
      var perPage = getPerPage();

      var lastRealStart = totalOriginal + totalOriginal - perPage;
      if(lastRealStart < totalOriginal) lastRealStart = totalOriginal;
      var lastRealCard = allCards[lastRealStart];
      var lastRealLeft = lastRealCard ? lastRealCard.offsetLeft - track.offsetLeft : 0;

      if(scrollLeft >= lastRealLeft - 1){
        var jumpCard = allCards[totalOriginal + (currentRealPage * perPage) % totalOriginal];
        if(jumpCard){
          track.scrollLeft = jumpCard.offsetLeft - track.offsetLeft;
        }
      }

      var firstCloneEndCard = allCards[totalOriginal - 1];
      var firstCloneEndLeft = firstCloneEndCard ? firstCloneEndCard.offsetLeft - track.offsetLeft : 0;
      if(scrollLeft <= firstCloneEndLeft + 1){
        var realIndex = (currentRealPage * perPage) % totalOriginal;
        var jumpBackCard = allCards[totalOriginal + totalOriginal - perPage + realIndex];
        if(!jumpBackCard) jumpBackCard = allCards[totalOriginal + totalOriginal - perPage];
        if(jumpBackCard){
          track.scrollLeft = jumpBackCard.offsetLeft - track.offsetLeft;
        }
      }

      currentRealPage = getRealPageFromScroll();
      updateDots();
    }

    function updateDots(){
      if(!dotsContainer) return;
      var totalRealPages = getTotalRealPages();

      if(dotsContainer.children.length !== totalRealPages){
        dotsContainer.innerHTML = '';
        for(var i = 0; i < totalRealPages; i++){
          var dot = document.createElement('button');
          dot.className = 'ks-video-dot';
          dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
          dot.setAttribute('data-page', i);
          dotsContainer.appendChild(dot);
        }
        dotsContainer.addEventListener('click', function(e){
          var dot = e.target.closest('.ks-video-dot');
          if(dot){
            var page = parseInt(dot.getAttribute('data-page'));
            if(!isNaN(page)){
              goToRealPage(page, true);
            }
          }
        });
      }

      var dots = dotsContainer.querySelectorAll('.ks-video-dot');
      dots.forEach(function(dot, i){
        if(i === currentRealPage){
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }

    if(prevBtn){
      prevBtn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        prevPage();
      });
    }
    if(nextBtn){
      nextBtn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        nextPage();
      });
    }

    var scrollTimer = null;
    track.addEventListener('scroll', function(){
      if(scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function(){
        currentRealPage = getRealPageFromScroll();
        updateDots();
        handleScrollEnd();
      }, 150);
    });

    var resizeTimer = null;
    window.addEventListener('resize', function(){
      if(resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function(){
        setupInfiniteLoop();
        currentRealPage = 0;
        updateDots();
      }, 200);
    });

    setupInfiniteLoop();
    currentRealPage = 0;
    updateDots();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  function startMarquee(){
    var wrap = document.querySelector('#ks-wrap .ks-marquee-wrap');
    var inner = document.querySelector('#ks-wrap .ks-marquee-inner');
    if(!wrap || !inner) return;
    var pos = 0;
    var speed = 1;
    var half = 0;
    function measure(){
      var items = inner.querySelectorAll('.ks-marquee-item');
      half = 0;
      for(var i = 0; i < items.length / 2; i++){
        half += items[i].offsetWidth;
      }
    }
    measure();
    window.addEventListener('resize', measure);
    setInterval(function(){
      pos -= speed;
      if(pos <= -half){ pos = 0; }
      inner.style.transform = 'translateX(' + pos + 'px)';
    }, 16);
  }
  startMarquee();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purelums-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('#plw .pf-item').forEach(function(f){f.addEventListener('click',function(){this.classList.toggle('op')})});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-autumn-harvest-floral-garden-stake"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('ahfg-wrap');
  if (!root) return;

  /* Video carousel arrows */
  var vidTrack = root.querySelector('.ahp-vid-tr');
  var vidLeft = root.querySelector('.ahp-vid-arr-l');
  var vidRight = root.querySelector('.ahp-vid-arr-r');
  if (vidLeft && vidTrack) vidLeft.addEventListener('click', function(){ vidTrack.scrollBy({ left: window.innerWidth >= 750 ? -380 : -300, behavior: 'smooth' }); });
  if (vidRight && vidTrack) vidRight.addEventListener('click', function(){ vidTrack.scrollBy({ left: window.innerWidth >= 750 ? 380 : 300, behavior: 'smooth' }); });

  /* Testimonials single-card carousel */
  var track = root.querySelector('.ahp-rev-track');
  if (track) {
    var cards = track.querySelectorAll('.ahp-rev-card');
    var n = cards.length;
    if (n > 0) {
      var idx = 0;
      var dotsWrap = root.querySelector('.ahp-rev-dots');
      var prevBtn = root.querySelector('.ahp-rev-prev');
      var nextBtn = root.querySelector('.ahp-rev-next');

      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ahp-rev-dot' + (i === 0 ? ' ahp-act' : '');
          dot.setAttribute('aria-label', 'Review ' + (i + 1));
          (function (target) {
            dot.addEventListener('click', function () { go(target); });
          })(i);
          dotsWrap.appendChild(dot);
        }
      }

      function go(i) {
        if (window.innerWidth >= 750) return;
        idx = ((i % n) + n) % n;
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
        if (dotsWrap) {
          var dots = dotsWrap.children;
          for (var k = 0; k < dots.length; k++) {
            if (k === idx) dots[k].classList.add('ahp-act');
            else dots[k].classList.remove('ahp-act');
          }
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1); });

      /* Touch swipe for mobile */
      var startX = null;
      track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { go(dx < 0 ? idx + 1 : idx - 1); }
        startX = null;
      }, { passive: true });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-body-exfoliating-scrub-pads"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('besp-wrap');
  if (!root) return;
/* ==========================================
   KEY INGREDIENTS CAROUSEL
   ========================================== */

var ingTrack = root.querySelector('.bes-ing-track');

if (ingTrack) {

  var ingCards =
    ingTrack.querySelectorAll('.bes-ing-card');

  var ingPrev =
    root.querySelector('.bes-ing-prev');

  var ingNext =
    root.querySelector('.bes-ing-next');

  var ingDots =
    root.querySelectorAll('.bes-ing-dot');

  var ingIndex = 0;


  function ingGo(index) {

    if (window.innerWidth >= 750) return;

    var total = ingCards.length;

    /* 最后一张再点右箭头 → 回到第一张 */
    ingIndex = ((index % total) + total) % total;

    var card = ingCards[ingIndex];

    ingTrack.scrollTo({
      left: card.offsetLeft,
      behavior:'smooth'
    });

    ingUpdateDots();
  }


  function ingUpdateDots() {

    ingDots.forEach(function(dot,index){

      if(index === ingIndex){
        dot.classList.add('bes-act');
      }else{
        dot.classList.remove('bes-act');
      }

    });

  }


  /* 左箭头 */
  if (ingPrev) {

    ingPrev.addEventListener('click', function(){

      ingGo(ingIndex - 1);

    });

  }


  /* 右箭头 */
  if (ingNext) {

    ingNext.addEventListener('click', function(){

      ingGo(ingIndex + 1);

    });

  }


  /* 点击圆点 */
  ingDots.forEach(function(dot,index){

    dot.addEventListener('click', function(){

      ingGo(index);

    });

  });


  /* 手指左右滑以后，圆点跟着改变 */
  var ingScrollTimer;

  ingTrack.addEventListener('scroll', function(){

    if(window.innerWidth >= 750) return;

    clearTimeout(ingScrollTimer);

    ingScrollTimer = setTimeout(function(){

      var width = ingTrack.clientWidth;

      if(!width) return;

      ingIndex = Math.round(
        ingTrack.scrollLeft / width
      );

      ingIndex = Math.max(
        0,
        Math.min(
          ingCards.length - 1,
          ingIndex
        )
      );

      ingUpdateDots();

    },80);

  });

}
  /* Before/After comparison slider - native range input */
  var baSlider = root.querySelector('comparison-slider.bes-ba-slider');
  if (baSlider) {
    var baRange = baSlider.querySelector('.bes-ba-range');
    if (baRange) {
      function updateBaSlider() {
        baSlider.style.setProperty('--bes-ba-pos', baRange.value + '%');
      }
      baRange.addEventListener('input', updateBaSlider);
      baRange.addEventListener('change', updateBaSlider);
      updateBaSlider();
    }
  }

  /* Video carousel: horizontal, 2 per screen (mobile), click-to-play, dots, arrows, swipe */
  var vidTrack = root.querySelector('.bes-vid-tr');
  if (vidTrack) {
    var slides = vidTrack.querySelectorAll('.bes-vid-sl');
    var n = slides.length;
    var vidLeft = root.querySelector('.bes-vid-arr-l');
    var vidRight = root.querySelector('.bes-vid-arr-r');
    var vidDots = root.querySelector('.bes-vid-dots');

    function perView() { return window.innerWidth >= 750 ? 3 : 2; }

    var groups = Math.ceil(n / perView());

    if (vidDots) {
      vidDots.innerHTML = '';
      for (var g = 0; g < groups; g++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bes-vid-dot' + (g === 0 ? ' bes-act' : '');
        dot.setAttribute('aria-label', 'Group ' + (g + 1));
        (function (target) {
          dot.addEventListener('click', function () {
            var step = slides[0].offsetWidth + 10;
            vidTrack.scrollTo({ left: target * step * perView(), behavior: 'smooth' });
          });
        })(g);
        vidDots.appendChild(dot);
      }
    }

    function scrollStep(dir) {
      var step = slides[0].offsetWidth + 10;
      vidTrack.scrollBy({ left: dir * step * perView(), behavior: 'smooth' });
    }
    if (vidLeft) vidLeft.addEventListener('click', function () { scrollStep(-1); });
    if (vidRight) vidRight.addEventListener('click', function () { scrollStep(1); });

    /* Sync dots with scroll position */
    vidTrack.addEventListener('scroll', function () {
      var step = slides[0].offsetWidth + 10;
      var g = Math.round(vidTrack.scrollLeft / (step * perView()));
      if (g < 0) g = 0;
      if (g > groups - 1) g = groups - 1;
      var dots = vidDots ? vidDots.children : [];
      for (var k = 0; k < dots.length; k++) {
        if (k === g) dots[k].classList.add('bes-act');
        else dots[k].classList.remove('bes-act');
      }
    });

    /* Click-to-play inline (no fullscreen, no navigation) */
    slides.forEach(function (card) {
      var video = card.querySelector('video');
      var btn = card.querySelector('.bes-vid-play');
      if (!video || !btn) return;
      btn.addEventListener('click', function () {
        video.muted = false;
        video.play();
        card.classList.add('bes-playing');
      });
      video.addEventListener('pause', function () { card.classList.remove('bes-playing'); });
      video.addEventListener('ended', function () { card.classList.remove('bes-playing'); });
    });
  }

  /* Reviews single-card carousel (mobile only) */
  var track = root.querySelector('.bes-rev-track');
  if (track) {
    var cards = track.querySelectorAll('.bes-rev-card');
    var rn = cards.length;
    if (rn > 0) {
      var idx = 0;
      var dotsWrap = root.querySelector('.bes-rev-dots');
      var prevBtn = root.querySelector('.bes-rev-prev');
      var nextBtn = root.querySelector('.bes-rev-next');

      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        for (var i = 0; i < rn; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'bes-rev-dot' + (i === 0 ? ' bes-act' : '');
          dot.setAttribute('aria-label', 'Review ' + (i + 1));
          (function (target) {
            dot.addEventListener('click', function () { go(target); });
          })(i);
          dotsWrap.appendChild(dot);
        }
      }

      function go(i) {
        if (window.innerWidth >= 750) return;
        idx = ((i % rn) + rn) % rn;
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
        if (dotsWrap) {
          var dots = dotsWrap.children;
          for (var k = 0; k < dots.length; k++) {
            if (k === idx) dots[k].classList.add('bes-act');
            else dots[k].classList.remove('bes-act');
          }
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1); });

      var startX = null;
      track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { go(dx < 0 ? idx + 1 : idx - 1); }
        startX = null;
      }, { passive: true });
    }
  }
})();

  } catch(e) { console.error(e); }
})();
})();
